import { createEvent } from "effector";
import type { RegResponse } from "../domain/rsportz";

export const doGetAthleteList = createEvent();
export const rsportzSent = createEvent<RegResponse>();
export const doSetMembership = createEvent<number>();
export const doSetMissingFields = createEvent<string[]>();
